import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import type { ConfirmationDialogData } from '../../interfaces/confirmation-dialog.interface';

@Component({
  selector: 'claims-confirmation-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './confirmation-dialog.component.html',
  styleUrl: './confirmation-dialog.component.scss',
  host: { 'class': 'e-confirmation-dialog' }
})
export class ConfirmationDialogComponent {
  
  constructor(
    public readonly dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: ConfirmationDialogData
  ) {}

  public onCancel(): void {
    this.dialogRef.close();
  }

  public onProceed(): void {
    this.dialogRef.close({action: 'delete' });
  }
}